
export enum AtribuicaoPeticaoInicial {
  DEFINIDA = 'DEFINIDA',
  PENDENTE = 'PENDENTE'
}